import { env } from "@/config/env";

/**
 * Reverse geocode coordinates into a human-readable place name.
 * Uses Mapbox Geocoding API v6.
 * Returns "Neighborhood, City" or just "City" or fallback coords.
 */
export async function reverseGeocode(
  lng: number,
  lat: number,
  language = "sv",
): Promise<string> {
  const token = env.mapbox.accessToken;
  if (!token) return formatCoords(lat, lng);

  try {
    const url = `https://api.mapbox.com/search/geocode/v6/reverse?longitude=${lng}&latitude=${lat}&types=address,neighborhood,place&language=${language}&limit=1&access_token=${token}`;
    const res = await fetch(url);
    if (!res.ok) return formatCoords(lat, lng);

    const data = await res.json();
    const feature = data.features?.[0];
    if (!feature) return formatCoords(lat, lng);

    const name = feature.properties?.name ?? "";
    const neighborhood = feature.properties?.context?.neighborhood?.name ?? "";
    const city = feature.properties?.context?.place?.name ?? "";

    // Prefer: "Address, City" > "Neighborhood, City" > "City"
    if (city && name && name !== city) return `${name}, ${city}`;
    if (city && neighborhood && neighborhood !== city) return `${neighborhood}, ${city}`;
    return city || name || formatCoords(lat, lng);
  } catch {
    return formatCoords(lat, lng);
  }
}

function formatCoords(lat: number, lng: number): string {
  return `${lat.toFixed(4)}°N, ${lng.toFixed(4)}°E`;
}
